import { trackEvent } from '@offerzen/pinata-shame'

export const trackCitizenshipCountryAddition = countryName => {
  trackEvent('Candidate: profile action', {
    action: 'selected citizenship country',
    source: 'onboarding',
    citizenshipStatus: 'citizen',
    country_name: countryName,
    currentState: 'onboarding',
  })
}

export const trackCitizenshipCountryRemoval = countryName => {
  trackEvent('Candidate: profile action', {
    action: 'removed citizenship country',
    source: 'onboarding',
    citizenshipStatus: 'citizen',
    country_name: countryName,
    currentState: 'onboarding',
  })
}

export const trackCitizenshipAddButton = () => {
  trackEvent('Candidate: profile action', {
    action: 'clicked add citizenship status',
    source: 'onboarding',
    currentState: 'onboarding',
  })
}

export const trackCitizenshipAddition = ({ countryName, citizenshipStatus, citizenshipId }) => {
  trackEvent('Candidate: profile action', {
    action: 'added citizenship status',
    source: 'onboarding',
    citizenshipId,
    citizenshipStatus,
    country_name: countryName,
    currentState: 'onboarding',
  })
}

export const trackCitizenshipEditButton = ({ countryName, citizenshipStatus, citizenshipId }) => {
  trackEvent('Candidate: profile action', {
    action: 'clicked update citizenship status',
    source: 'onboarding',
    citizenshipId,
    citizenshipStatus,
    country_name: countryName,
    currentState: 'onboarding',
  })
}

export const trackCitizenshipEdit = ({ countryName, citizenshipStatus, citizenshipId }) => {
  trackEvent('Candidate: profile action', {
    action: 'citizenship status update',
    source: 'onboarding',
    citizenshipId,
    citizenshipStatus,
    country_name: countryName,
    currentState: 'onboarding',
  })
}

export const trackCitizenshipDeleteButton = ({ countryName, citizenshipStatus, citizenshipId }) => {
  trackEvent('Candidate: profile action', {
    action: 'clicked remove citizenship status',
    source: 'onboarding',
    citizenshipId,
    citizenshipStatus,
    country_name: countryName,
    currentState: 'onboarding',
  })
}

export const trackCitizenshipDelete = ({ countryName, citizenshipStatus, citizenshipId }) => {
  trackEvent('Candidate: profile action', {
    action: 'removed citizenship status',
    source: 'onboarding',
    citizenshipId,
    citizenshipStatus,
    country_name: countryName,
    currentState: 'onboarding',
  })
}
